const urlsList = {
    "/rest": "rest.json",
    "/faq": "faq.json",
    "/conditions": "conditions.json",
    "/o-pravilnom-podhode-k-prigotovleniyu-rollov": "o-pravilnom-podhode-k-prigotovleniyu-rollov.json",
    // "/robots.txt": 'robots.txt', формируется через \modules\robots-txt
};
export default urlsList;
